export const type = [
  "FORNECEDOR/CLIENTE"
] 

export const businessUnit = [
  "201-LOJAS AVENIDA SA"
]